<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { FEATURE_FLAG } from '~/app/enums/FeatureFlag';

    const { closeLatestModal } = useModalsStore();
    const { displayOverlay } = storeToRefs(useModalsStore());
    const featureFlag = useFeatureFlag();
</script>

<template>
    <div
        :tabindex="displayOverlay ? 99 : -1"
        @keydown.esc="closeLatestModal"
    >
        <!-- Its own component so that a sheet's swipe, which fades these overlays on
             every finger move, re-renders them alone rather than this whole file. -->
        <LayoutModalsBackdrop />

        <AiAssistantModal v-if="featureFlag.isEnabled(FEATURE_FLAG.AI_ASSISTANT)" />

        <AppSearchModal />
        <AppCouponsModal />

        <AuthLoginQRCodeModal />
        <CobrowseRequestSheet />
        <AuthUserModal />
        <AuthTenantLiveModeModal />

        <WorksiteWorksiteUploadDropZone />

        <ContactContactContextMenu />
        <ContactContactModal />
        <ContactContactFormModal />
        <ContactContactImportModal />
        <ContactContactFormModalsDestroyUserAlert />

        <CrmLeadContextMenu />
        <CrmLeadFormModal />
        <!-- // TODO IT IS A CRM LEAD MODAL OR INVOICE ?  -->
        <CrmLeadQuoteModal />
        <CrmSourceFormModal />

        <TaskTaskContextMenu />
        <TaskTaskModal />
        <TaskTaskFormModal />

        <InventoryProductContextMenu />
        <InventoryProductFormModal />
        <InventoryProductImportModal />
        <InventoryProductUnitContextMenu />
        <InventoryProductUnitFormModal />
        <InventoryProductCategoryContextMenu />
        <InventoryProductCategoryFormModal />
        <InventoryProductSectionContextMenu />
        <InventoryProductSectionFormModal />

        <InvoicingExpenseContextMenu />
        <InvoicingExpenseAddContactModal />
        <InvoicingExpenseAddWorksiteModal />
        <InvoicingExpensesExportModal />
        <InvoicingInvoiceModal />
        <InvoicingInvoiceContextMenu />
        <InvoicingInvoiceDeleteAlert />
        <InvoicingInvoicePreviewHtml />
        <InvoicingInvoiceLinkToWorksite />
        <InvoicingInvoiceAddContactModal />
        <InvoicingInvoiceChangeStatus />
        <InvoicingInvoiceMarkAsSent />
        <InvoicingInvoiceSendEmail />
        <InvoicingInvoiceSendSMS />
        <InvoicingInvoiceSendPaymentReminder />
        <InvoicingInvoiceReplicate />
        <InvoicingInvoiceDepositInvoice />
        <InvoicingInvoiceFinalInvoice />
        <InvoicingInvoiceFrenchVatCertificate />
        <!-- <InvoicingInvoicePayment /> -->
        <InvoicingInvoicePaymentFormModal />
        <InvoicingInvoicePaymentContextMenu />
        <InvoicingInvoiceDiscountFormModal />
        <InvoicingInvoiceDiscountContextMenu />
        <InvoicingVatRateContextMenu />
        <InvoicingVatRateFormModal />
        <InvoicingInvoicingPaymentRemindersSettingContextMenu />
        <InvoicingInvoicingPaymentRemindersSettingFormModal />
        <InvoicingInvoiceTemplateContextMenu />
        <InvoicingInvoiceTemplateFormModal />
        <InvoicingInvoiceTemplateSectionContextMenu />
        <InvoicingInvoiceTemplateSectionFormModal />
        <InvoicingInvoiceTemplateSectionColumnContextMenu />
        <InvoicingInvoiceTemplateSectionColumnFormModal />
        <InvoicingInvoiceTemplateReplicate />
        <InvoicingSettingsInvoiceAnnexPdfModal />
        <InvoicingSettingsInvoiceAnnexPdfContextMenu />
        <InvoicingInvoicesExportModal />
        <InvoicingInvoiceSelectContact />
        <InvoicingInvoiceFormModalsEditDisabled />

        <InvoicingExpenseMarkAsPaidModal />
        <InvoicingInvoiceUpdatingConditionAlert />

        <InvoicingInvoiceModal />
        <InvoicingInvoiceEvidenceModal />

        <InvoicingInvoiceModelModal />
        <InvoicingExpenseMarkAsPaidModal />

        <PlanningTimeActivityContextMenu />
        <PlanningTimeActivityModal />
        <PlanningTimeActivityFormModal />
        <PlanningCalendarEventContextMenu />
        <PlanningCalendarEventModal />
        <PlanningCalendarEventFormModal />
        <PlanningTimeActivityLinkInvoice />
        <PlanningTimeActivityInvoiceMultiple />

        <WorksiteWorksiteContextMenu />
        <WorksiteWorksiteModal />
        <WorksiteWorksiteFormModal />

        <CommonWasteCenterFormModal />
        <CommonModelFileContextMenu />
        <CommonModelFileModal />
        <CommonModelFileMoveModal />
        <CommonModelFileFolderContextMenu />
        <CommonModelFileFolderFormModal />
        <CommonMeilisearchHitContextMenu />
        <CommonFilesExportModal />
        <CommonFilesExportInstructionModal />
        <CommonFilesAddFileModal />

        <WorksiteWorksitePhaseFormModal />
        <WorksiteWorksitePhaseContextMenu />
        <WorksiteWorksiteProfitabilityDocumentContextMenu />
        <WorksiteWorksiteProfitabilityDocumentModal />
        <WorksiteWorksiteProfitabilityDocumentFormModal />
        <WorksiteWorksiteProgressBillingContextMenu />
        <WorksiteWorksiteProgressBillingSettingModal />
        <WorksiteWorksiteProgressBillingValidationModal />
        <WorksiteWorksiteProgressBillingInvoiceModal />
        <WorksiteWorksiteProgressBillingForceSavingProgressBillingModal />
        <WorksiteWorksiteClosureReportsFormModal />
        <WorksiteWorksiteClosureReportsContextMenu />
        <WorksiteWorksiteClosureReportsSendEmail />
        <WorksiteWorksiteProgressBillingModalsQuoteEditDisableInfo />
        <CommonNotificationsLogsModal />
        <CommonKonamiCodeModal />
        <CommonTermsOfServiceAcceptModal />
        <CommonUpsellGenericModal />

        <BankaccountAssignInvoiceToTransactionModal />

        <SettingsSpotsModal />
        <SettingsSubscriptionInfo />
        <SettingsCreditModal />

        <InvoicingInvoicePaymentReminderGroupsFormModal />
        <InvoicingInvoicePaymentReminderGroupsContextMenu />
        <TeleportTarget id="modals-teleport-safe-target" />
        <div id="modals-teleport-target"></div>
    </div>
</template>
